"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IStatisticBase.js.map